import script from "./EditSection.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSection.vue?vue&type=script&setup=true&lang=js"

import "./EditSection.vue?vue&type=style&index=0&id=7404c174&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7404c174"]])

export default __exports__